<template>
    <div class="search-result-panel">
        <span class="search-result-panel-title">
            {{ title }} <span v-if="showCount">({{ count }})</span>
        </span>
        <a href="#" v-if="showViewAll" @click.stop.prevent="viewAll"> View All &gt; </a>
        <div class="search-result-panel-content" v-if="count > 0">
            <slot></slot>
        </div>
        <div class="search-result-panel-content empty-block" v-else>
            <p>Your search did not match any results</p>
        </div>
    </div>
</template>
<script setup>
defineProps({
    title: {
        type: String,
        required: true,
    },
    count: {
        type: Number,
        required: true,
    },
    showCount: {
        type: Boolean,
        default: true,
    },
    showViewAll: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['viewAll'])

function viewAll() {
    emit('viewAll')
}
</script>
<style>
.search-result-panel .search-result {
    border-bottom: 1px solid var(--color-alpha-1);
    padding: 16px 0;

    .button-group {
        align-self: center;
        margin: 0;

        button {
            width: 140px;
        }
    }
}
</style>
<style scoped>
.search-result-panel {
    align-self: center;
    display: grid;
    grid-template-areas:
        'title view-all'
        'content content';
    margin: 0;
    padding: 0 16px;
}

.search-result-panel > a {
    align-self: center;
    grid-area: view-all;
    color: var(--color-focus);
    cursor: pointer;
    font-size: var(--font-size-detail);
    font-weight: var(--weight-bold);
    padding-right: 16px;
    line-height: 24px;
    text-transform: uppercase;
    text-align: right;

    &:hover {
        color: var(--color-secondary-400);
    }
}

.search-result-panel-title {
    color: var(--color-primary-600);
    grid-area: title;
    font-size: 13px;
    text-transform: uppercase;
    line-height: 48px;
    font-weight: var(--weight-medium);
}

.search-result-panel-content {
    grid-area: content;
}
</style>
